import { useMutation } from "react-query";

import { updatePaymentCheck } from 'api/payment'

export default function usePaymentResult() {
  return useMutation<{
    result: string;
    message: string | null;
  }, Error, { saleTID: string; }>(async ({ saleTID }) => {
    return await updatePaymentCheck({ saleTID })
  });
}